import { SessaoViewModel } from "./../../api/model/sessao/sessao-view-Model";
import { jwtAuthService } from "../../api/module/erp/services/auth/jwtAuthService";
import { Component, OnInit } from "@angular/core";
import {
  Location,
} from "@angular/common";
import { Router } from "@angular/router";
import { ContaService } from "src/app/api/module/erp/services/auth/conta.service";
import { AtualizacaoForcadaService } from "src/app/api/module/erp/shared/services/atualizacao-forcada-service.service";
import { CompartilharDadosEntreComponentsService } from "src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  public focus: any;
  public listTitles!: any[];
  public location: Location;
  rules: string = "";
  nomeUsuario: string = "";
  dadosUsuarioLogado = new SessaoViewModel();
  dadosParaCompartilhar: any

  constructor(
    location: Location,
    private router: Router,
    private contaService: ContaService,
    private jwt: jwtAuthService,
    private _atualizacaoForcadaService: AtualizacaoForcadaService,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService

  ) {
    this.location = location;
  }

  ngOnInit() {
    if (this.jwt.isUsuarioLogado()) {
      this.nomeUsuarioNavbar()
      this._atualizacaoForcadaService.atualizacaoForcadaNavBarSubject$.subscribe(
        () => {
          let name: string = ''
          this.contaService.updateNameProfileUser.subscribe(message => name = message)
          this.updateUserName(name)
        }
      )

    } else {
      this.onLogout();
    }
  }

  onLogout() {
    this.contaService.onlogOut();
    this.router.navigate(["/login"]);
  }

  updateUserName(name: any) {
    if (name && name.length > 10) {
      this.nomeUsuario = name.slice(0, 10) + "...";
    } else return (this.nomeUsuario = name);
  }

  nomeUsuarioNavbar(){
    let data = this.jwt.sessaoService();
    if (data.name && data.name.length > 10) {
      this.nomeUsuario = data.name.slice(0, 10) + "...";
    } else {

      return (this.nomeUsuario = data.name);
    }
  }
}
